// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__I9Sug","head":"Table_head__2Dt19","col":"Table_col__lWIsK"};